import { render } from "preact";
import { Capacitor } from "@capacitor/core";
import "@/styles/base.css";
// Premium layer (2026-09-29): after base, before every feature stylesheet.
import "@/styles/premium.css";
// Uber layer (2026-10-20): flattens the premium look; still before every feature stylesheet.
import "@/styles/uber.css";
import "@/preview/preview.css";
import { embeddedInStage, previewMode, readDevice, STAGE_QUERY } from "@/preview/mode";
import { installDevice } from "@/preview/embed";

// Global error surface: never a silent blank screen again.
window.addEventListener("error", (e) => {
  console.error("[STATUS] uncaught", e.error ?? e.message);
  showFatal(e.error ?? e.message);
});
window.addEventListener("unhandledrejection", (e) => {
  console.error("[STATUS] unhandled rejection", e.reason);
});

function showFatal(err: unknown): void {
  const el = document.getElementById("app");
  if (!el || el.childElementCount > 0) return;
  el.innerHTML = `<div style="padding:24px;font-family:system-ui;color:#f2f2f5;background:#0b0b0e;min-height:100vh">
    <h2>STATUS hit a problem while starting.</h2>
    <p style="opacity:.7">Your data is still on this device. Reload to try again; if it keeps happening, export your data from More → Data on a build that starts.</p>
    <pre style="white-space:pre-wrap;font-size:12px;opacity:.6">${String(err instanceof Error ? err.stack ?? err.message : err).replace(/</g, "&lt;")}</pre>
    <button onclick="location.reload()" style="margin-top:12px;padding:12px 18px;border-radius:12px;border:0;font-weight:600">Reload</button>
  </div>`;
}

// iPhone preview (2026-09-29): STATUS is an iPhone app. A desktop browser gets a device
// stage that runs the app in an iPhone-sized iframe; phones and the native shell get the
// app directly. The app module loads only where the app actually runs.
const root = document.getElementById("app")!;
const mode = previewMode({
  desktop: window.matchMedia?.(STAGE_QUERY).matches ?? false,
  embedded: embeddedInStage(),
  native: Capacitor.isNativePlatform(),
});

if (mode === "stage") {
  void import("@/preview/DevicePreview").then(({ DevicePreview }) => render(<DevicePreview />, root));
} else {
  if (mode === "device") installDevice(readDevice());
  void import("./app").then(({ App }) => render(<App />, root));
}
